import {gql} from "@apollo/client";

export const GQL_IS_IT_DOWN_SERVICES_QUERY = gql`
  query IsItDownServices(
    $limit: Int
    $offset: Int
    $search: String
    $service_status: [IsItDownServiceStatus!]
    $sort: IsItDownServiceSort
    $categories: [String!]
  ) {
    isItDownServices(
      limit: $limit
      offset: $offset
      search: $search
      service_status: $service_status
      sort: $sort
      categories: $categories
    ) {
      total
      items {
        id
        slug
        name
        image
        service_status
      }
    }
  }
`;

export const PUBLIC_CLOUD_STATUS_GROUPS_QUERY = gql`
  query PublicCloudStatusGroups($orderBy: String) {
    publicCloudStatusGroups(orderBy: $orderBy) {
      total
      items {
        id
        slug
        name
        image
        service_status
      }
    }
  }
`;

export const GQL_IS_IT_DOWN_SERVICE_QUERY = gql`
  query IsItDownService($slug: String!) {
    service: isItDownService(slug: $slug) {
      ... on IsItDownService {
        id
        slug
        name
        description
        twitter
        status_page
        image
        service_status
        service_id
        variant
      }
      ... on ErrorResponse {
        status
        message
      }
    }
    stats: publicProfileStats(slug: $slug) {
      ... on PublicProfileStats {
        service_msp_interval
        service_created_at
        totals {
          uptime_pct
          downtime_secs
          outages
        }
        intervals {
          interval_start
          interval_end
          is_down_at_start
          is_down_at_end
          alerts {
            id
            state_is_up
            created_at
            ended_at
            output
          }
        }
        available_locations {
          id
          location
        }
        location_response_times {
          id
          data {
            timestamp
            value
          }
        }
        last_check_timestamp
        latest_downtime {
          is_currently_down
          created_at
          ended_at
          duration
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
    categoryStats: publicProfilesDownCategoryStats(slug: $slug) {
      status
      total
      items {
        id
        name
        count
      }
      timestamps
    }
    incidents: publicProfilesIncidentHistory(slug: $slug) {
      total
      items {
        id
        title
        status
        created_at
        updated_at
      }
    }
    components: publicProfilesComponentStatus(slug: $slug) {
      total
      items {
        id
        name
        status
        status_started_at
        status_updated_at
      }
    }
    similarServices: publicProfilesSimilarServices(slug: $slug) {
      id
      slug
      name
      image
    }
  }
`;

export const GQL_PUBLIC_PROFILES_RECENT_OUTAGES_QUERY = gql`
  query PublicProfilesRecentOutages($limit: Int, $offset: Int) {
    publicProfilesRecentOutages(limit: $limit, offset: $offset) {
      total
      items {
        id
        incident_title
        incident_start
        incident_duration
        group_logo
        group_name
      }
    }
  }
`;

export const GQL_PUBLIC_PROFILES_SUBSCRIBE = gql`
  mutation PublicProfilesSubscribe($data: PublicProfilesSubscribeInput!) {
    publicProfilesSubscribe(data: $data) {
      ... on PublicProfilesSubscribeSuccess {
        status
        data {
          subscribed
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_PUBLIC_PROFILES_DOWN_REPORT = gql`
  mutation PublicProfilesDownReport($data: PublicProfilesDownReportInput!) {
    publicProfilesDownReport(data: $data) {
      ... on PublicProfilesDownReportSuccess {
        status
        data {
          created
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_CATEGORIES_QUERY = gql`
  query GetPublicProfileCategories($only_used: Boolean, $order_by_importance: Boolean, $all: Boolean) {
    publicProfileCategories(only_used: $only_used, order_by_importance: $order_by_importance, all: $all) {
      id
      name
    }
  }
`;
